import * as React from 'react'
import Head from 'next/head'
import { useRouter } from 'next/router'

import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarTitle,
} from '@wartek-id/header-bar'
import { Icon } from '@wartek-id/icon'

import MyAssessmentList from 'app/AssessmentPage/Me/List'
import AndroidHandler from 'utils/androidHandler'

const title = 'AKM Kelas Saya'

const PageHeader = () => {
  const router = useRouter()
  const androidHandler = AndroidHandler()

  return (
    <HeaderBar fixed className="z-10">
      <HeaderBarLeftAction
        icon={
          <Icon as="i" color="default">
            arrow_back
          </Icon>
        }
        onClick={async () => {
          if (androidHandler.enabled) {
            androidHandler.backToApp()
          } else {
            await router.push('/home')
          }
        }}
      />
      <HeaderBarTitle>{title}</HeaderBarTitle>
    </HeaderBar>
  )
}

const MyAssessment = () => {
  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>

      <MyAssessmentList />
    </>
  )
}

MyAssessment.layoutOpts = {
  hasHeader: true,
  header: PageHeader,
}

export default MyAssessment
